import React from 'react'
import { Carousel } from 'react-bootstrap'
import Arrow from './../../../../common/images/arrow.svg'
import { StyledCarouselWrapper, StyledCarouselControl} from './styled'

const Photos = (props) => {
    const [index, setIndex] = React.useState(0);

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    const handleSlideChange = (direction) => {
        if(direction === 'next') {
            if(index < props.photos.length -1) setIndex( index + 1)
        }

        if(direction === 'prev') {
            if(index > 0) setIndex(index- 1)
        }

    }

    return (
        <StyledCarouselWrapper>
            <StyledCarouselControl side='left' onClick={() => handleSlideChange('prev')}>
                <img src={Arrow} alt=''/>
            </StyledCarouselControl>

            <StyledCarouselControl side='right' onClick={() => handleSlideChange('next')}>
                <img src={Arrow} alt=''/>
            </StyledCarouselControl>
                <Carousel activeIndex={index} onSelect={handleSelect}  controls={false} indicators={false} interval={5000}>
                    {
                        props.photos.map(image => (
                            <Carousel.Item>
                                <img
                                    className="d-block w-100"
                                    src={image.image.url}
                                    alt={image.image.alt}
                                />
                            </Carousel.Item>
                        ))
                    }
                </Carousel>
        </StyledCarouselWrapper>
    )
}

export default Photos